import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createBlock(_component_Tooltip, { class: "create-projects__label-tooltip" }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("При сумме меньше млрд руб. необходимо ввести значение в виде десятичной дроби с использованием точки (например, 300 млн руб. вводится в ячейку как 0.3 млрд руб.)", -1)
    ]))]),
    _: 1
  }))
}